import styled from "styled-components";

const KomonNavigationNavbarAuto = styled.div`
  flex-grow: 1;
`;

export default KomonNavigationNavbarAuto;
